import { Component, Input, OnInit } from '@angular/core'
import { HelpersService } from 'src/app/services/helpers/helpers.service'

@Component({
	selector: 'app-product-banner',
	templateUrl: './product-banner.component.html',
	styleUrls: ['./product-banner.component.scss'],
})
export class ProductBannerComponent implements OnInit {
	constructor(private helpers: HelpersService) {}
	

	@Input() data: any = []

	ngOnInit(): void {}

	removeLangFromRoute(url: any) {
		return this.helpers.removeLangFromRoute(url)
	}
}
